import { Link, Toolbar } from 'framework7-react';
import { ToolbarProps } from 'framework7-react/components/toolbar';
import { Router } from 'framework7/types';
import { FC } from 'react';
// import './NewsTabBarText.scss';
import style from './NewsTabBarTextStyle.module.css';
import './NewsTabBarText.scss';

interface TabBarTextProps extends ToolbarProps {
  tabs: Router.RouteParameters[];
}
export const TabBarText: FC<TabBarTextProps> = ({ tabs, ...props }) => {
  return (
    <Toolbar
      className={`${style['toolbar']} tabbar-text`}
      tabbar
      labels
      noHairline
    >
      <div className={style['tabs-wrapper']}>
        {tabs.map((tab: any) => (
          <Link
            className="no-ripple"
            tabLink
            animate
            key={tab.id}
            href={`.${tab.path}`}
            icon={tab.options.props.icon}
            routeTabId={tab.id}
          >
            <span
              style={{
                fontSize: tab.options.props.fontSize,
                whiteSpace: 'pre',
                textAlign: 'center',
              }}
            >
              {tab.options.props.tabText}
            </span>
          </Link>
        ))}
      </div>
    </Toolbar>
  );
};
